import { Routes } from '@angular/router';

export const BI_DASHBOARDS_ROUTES: Routes = [
  {
    path: 'dashboards',
    loadComponent: () =>
      import('./BI-dashboards.component').then(m => m.BIDashboardsComponent),
    children: [
      {
        path: 'labor-dashboard',
        title: 'Labor Dashboard',
        loadComponent: () =>
          import('./pages/labor-dashboard/labor-dashboard.component').then(
            m => m.LaborDashboardComponent,
          ),
      },
      {
        path: 'safety-dashboard-svp',
        title: 'Safety Dashboard SVP',
        loadComponent: () =>
          import('./pages/safety-dashboard/pages/safety-dashboard-svp/safety-dashboard-svp.component').then(
            m => m.SafetyDashboardSvpComponent,
          ),
      },
      {
        path: 'safety-dashboard-rsd',
        title: 'Safety Dashboard RSD',
        loadComponent: () =>
          import('./pages/safety-dashboard/pages/safety-dashboard-rsd/safety-dashboard-rsd.component').then(
            m => m.SafetyDashboardRsdComponent,
          ),
      },
      {
        path: 'safety-dashboard-om',
        title: 'Safety Dashboard OM',
        loadComponent: () =>
          import('./pages/safety-dashboard/pages/safety-dashboard-om/safety-dashboard-om.component').then(
            m => m.SafetyDashboardOmComponent,
          ),
      },
      {
        path: 'safety-intelligence-dashboard',
        title: 'Safety Intelligence',
        loadComponent: () =>
          import('./pages/safety-intelligence/safety-intelligence').then(
            m => m.SafetyIntelligence,
          ),
      },
      {
        path: '',
        redirectTo: 'labor-dashboard',
        pathMatch: 'full',
      },
    ],
  },
];
